// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"66":"232d1215","453":"7c17016b"}[chunkId] + ".chunk.js";
};